import Vue from 'vue'
import Vuex from 'vuex'

import user from '@/store/modules/user'
import games from '@/store/modules/games'
import systems from '@/store/modules/systems'

import axios from 'axios'
axios.defaults.baseURL = process.env.VUE_APP_RAILS_API_URL

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    games,
    systems
  },
  state: {
  },
  mutations: {
  },
  actions: {
  }
})
